import { useEffect } from "react"

export const useOutsideAlerter = (
  ref: React.RefObject<HTMLElement>,
  handleMenuOpen: (value: boolean) => void,
  className?: string
) => {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: MouseEvent | TouchEvent) {
      if (className && document.getElementsByClassName(className)) {
        const elements = document.getElementsByClassName(className)
        let flag = true
        Array.from(elements).forEach(e => {
          if (e.contains(event.target as HTMLElement)) flag = false
        })
        return flag ? handleMenuOpen(false) : null
      }
      if (ref.current && !ref.current.contains(event.target as HTMLElement)) {
        handleMenuOpen(false)
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [ref])
}
